import { Component, Input } from '@angular/core';

@Component({
    selector   : 'my-textarea',
    template: require('./textarea.component.html'),
    styles: [require('./textarea.component.scss')]
})

export class TextareaComponent {

    @Input('model') model: any;
    @Input('field') field: string;
    @Input('customClass') customClass: string;
    @Input('state') state:boolean = true;
    @Input('disabled') disabled:boolean = false;
    @Input('placeholder') placeholder:string = '';

    constructor() {
    }

    save(value){
        this.model[this.field] = value;
        this.model.modelChange(this.field);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/textarea/textarea.component.ts